'use client'

import { useBackInStockModalContext } from 'back-in-stock/src/hooks/useBackInStockModalContext/useBackInStockModalContext'
import { ButtonPrimary } from 'fukku/Button/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { cx } from 'utils/cx'

import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import { useProduct } from '../../contexts/ProductProvider/ProductProvider'
import { useSizes } from '../../contexts/SizesProvider/SizesProvider'
import { getIsBackInStock } from '../../utils/getIsBackInStock/getIsBackInStock'

import styles from './BackInStockButton.module.scss'

type BackInStockButtonProps = {
	className?: string
}

export function BackInStockButton({
	className,
}: BackInStockButtonProps): React.ReactNode {
	const { t } = useLabels()
	const { selectedColor } = useColors()
	const { product } = useProduct()
	const { openSheet, selectedSize, hasRelatedSizes } = useSizes()
	const { openProductSubscription } = useBackInStockModalContext()
	const {
		country: { hasOnlineSale },
	} = useMasterData()

	const shouldShowBackInStock = getIsBackInStock(
		hasRelatedSizes,
		hasOnlineSale,
		selectedSize,
		selectedColor
	)

	const handleClick = (): void => {
		if (selectedColor.isUniqueSize || selectedSize) {
			openProductSubscription({
				productId: product.id,
				productName: product.name,
				productColorId: selectedColor.id,
				productSizeId: selectedSize?.id || '',
				feedbackDelay: 0,
			})
		} else {
			openSheet(true)
		}
	}

	return (
		shouldShowBackInStock && (
			<ButtonPrimary
				className={cx(styles.backInStockButton, className)}
				onClick={handleClick}
			>
				{t('notifyMe.pdp.button')}
			</ButtonPrimary>
		)
	)
}
